<template>
  <BaseModal overlay-class="zb_modal">
    <div class="content">
      <BaseImage :src="image" alt="Bonus Game" />

      <h3 class="top_title">
        {{ $_translations.value[description.pt1] }}
        <span class="yellow_bold">
          {{ $_translations.value[description.pt2] }}
        </span>
        {{ $_translations.value[description.pt3] }}
      </h3>

      <p>{{ $_translations.value[description.pt4] }}</p>

      <BaseButton
        v-if="canPlay"
        @click:button="$emit('start:newBonusGame', gameType)"
      >
        {{ $_translations.value.modal_bonus_game_button_proceed }}
      </BaseButton>

      <div v-else class="error_text">
        {{ $_translations.value.modal_bonus_game_error_already_played }}
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import { computed } from 'vue';
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseButton from '@/components/button/BaseButton.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import { bonusGameTypeEnum } from '@/constants/game.js';
import { lanternsBonusGameImage, puzzleBonusGameImage } from '@/constants/image.js';

defineEmits(['start:newBonusGame']);

const props = defineProps({
  gameType: {
    type: String,
    default: '',
    validator: (value) => Object.values(bonusGameTypeEnum).includes(value),
  },
  canPlay: {
    type: Boolean,
    default: true,
  },
});

const image = computed(() => {
  if (props.gameType === bonusGameTypeEnum.BONUS_GAME_PUZZLE) {
    return puzzleBonusGameImage;
  } else if (props.gameType === bonusGameTypeEnum.BONUS_GAME_LANTERNS) {
    return lanternsBonusGameImage;
  } else {
    return '';
  }
});

const description = computed(() => ({
  pt1: 'modal_bonus_game_description_pt1',
  pt2: {
    [bonusGameTypeEnum.BONUS_GAME_PUZZLE]: 'modal_bonus_game_description_pt2_puzzle',
    [bonusGameTypeEnum.BONUS_GAME_LANTERNS]: 'modal_bonus_game_description_pt2_lanterns',
  }[props.gameType] || '',
  pt3: 'modal_bonus_game_description_pt3',
  pt4: 'modal_bonus_game_description_pt4',
}));
</script>
